import { configs } from '../../config';

export const getDocusignRedirectData = (investorId) => {
  const data = localStorage.getItem(`docusign-redirect-${investorId}`);
  if (configs.ENABLE_INVESTMENT_MFE) return JSON.parse(data || '{}');
  return data;
};

export const setDocusignRedirectData = (
  issuerId,
  opportunityId,
  investorId,
  currentPage,
) => {
  const redirectData = getDocusignRedirectData(investorId);
  let redirectValue;
  if (configs.ENABLE_INVESTMENT_MFE) {
    redirectData[issuerId] = opportunityId;
    redirectValue = JSON.stringify(redirectData);
  } else {
    redirectValue = `${currentPage}?redirected=true`;
  }
  localStorage.setItem(`docusign-redirect-${investorId}`, redirectValue);
};

export const deleteDocusignRedirectData = (issuerId, investorId) => {
  const redirectData = getDocusignRedirectData(investorId);
  const key = `docusign-redirect-${investorId}`;

  if (configs.ENABLE_INVESTMENT_MFE && Object.keys(redirectData).length > 0) {
    delete redirectData[issuerId];
    localStorage.setItem(key, JSON.stringify(redirectData));
  } else {
    localStorage.removeItem(key);
  }
};

export const getDocusignRedirectUrl = (investorId, issuerId) => {
  const opportunity = getDocusignRedirectData(investorId)[issuerId];
  return configs.ENABLE_INVESTMENT_MFE
    ? `/opportunity/${opportunity}/investment?redirected=true`
    : localStorage.getItem(`docusign-redirect-${investorId}`) || '/home';
};
